import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Dialog, { dialogClasses } from '@mui/material/Dialog';
import { styled } from '@mui/material/styles';
import { DIALOG_WIDTH } from './constants/dimensions';
var PickersModalDialogRoot = styled(Dialog)(_defineProperty(_defineProperty({}, "& .".concat(dialogClasses.container), {
  outline: 0
}), "& .".concat(dialogClasses.paper), {
  outline: 0,
  minWidth: DIALOG_WIDTH
}));
var PickersModalDialogContent = styled(DialogContent)({
  '&:first-of-type': {
    padding: 0
  }
});
var PickersModalDialogActions = styled(DialogActions)(function (_ref) {
  var ownerState = _ref.ownerState;
  return _objectSpread({}, (ownerState.clearable || ownerState.showTodayButton) && {
    // set justifyContent to default value to fix IE11 layout bug
    // see https://github.com/mui/material-ui-pickers/pull/267
    justifyContent: 'flex-start',
    '& > *:first-of-type': {
      marginRight: 'auto'
    }
  });
});
var PickersModalDialog = function PickersModalDialog(props) {
  var _props$cancelText = props.cancelText,
    cancelText = _props$cancelText === void 0 ? 'Cancel' : _props$cancelText,
    children = props.children,
    _props$clearable = props.clearable,
    clearable = _props$clearable === void 0 ? false : _props$clearable,
    _props$clearText = props.clearText,
    clearText = _props$clearText === void 0 ? 'Clear' : _props$clearText,
    _props$DialogProps = props.DialogProps,
    DialogProps = _props$DialogProps === void 0 ? {} : _props$DialogProps,
    _props$okText = props.okText,
    okText = _props$okText === void 0 ? 'OK' : _props$okText,
    onAccept = props.onAccept,
    onClear = props.onClear,
    onDismiss = props.onDismiss,
    onSetToday = props.onSetToday,
    open = props.open,
    _props$showTodayButto = props.showTodayButton,
    showTodayButton = _props$showTodayButto === void 0 ? false : _props$showTodayButto,
    _props$todayText = props.todayText,
    todayText = _props$todayText === void 0 ? 'Today' : _props$todayText;
  var ownerState = props;
  return /*#__PURE__*/React.createElement(PickersModalDialogRoot, _extends({
    open: open,
    onClose: onDismiss
  }, DialogProps), /*#__PURE__*/React.createElement(PickersModalDialogContent, null, children), /*#__PURE__*/React.createElement(PickersModalDialogActions, {
    ownerState: ownerState
  }, clearable && /*#__PURE__*/React.createElement(Button, {
    "data-mui-test": "clear-action-button",
    onClick: onClear
  }, clearText), showTodayButton && /*#__PURE__*/React.createElement(Button, {
    "data-mui-test": "today-action-button",
    onClick: onSetToday
  }, todayText), cancelText && /*#__PURE__*/React.createElement(Button, {
    onClick: onDismiss
  }, cancelText), okText && /*#__PURE__*/React.createElement(Button, {
    onClick: onAccept
  }, okText)));
};
export default PickersModalDialog;